import { useCallback, useEffect, useState } from "react";

// web-rnw twin of ./useSeenOnce.ts (see that file's header) — same per-device
// flag, localStorage instead of AsyncStorage. The split lives HERE rather than
// once per caller: before R7 it was duplicated in Logger/useNotesRead.web.ts,
// and a second control needing the same flag would have made it three.

export function useSeenOnce(storageKey: string | null): {
  seen: boolean;
  markSeen: () => void;
} {
  const [seen, setSeen] = useState(true);

  useEffect(() => {
    if (!storageKey) {
      setSeen(true);
      return;
    }
    let value: string | null = null;
    try {
      value = localStorage.getItem(storageKey);
    } catch {
      value = null;
    }
    setSeen(value === "1");
  }, [storageKey]);

  const markSeen = useCallback(() => {
    setSeen(true);
    if (storageKey) {
      try {
        localStorage.setItem(storageKey, "1");
      } catch {
        // quota exceeded / private mode — non-fatal.
      }
    }
  }, [storageKey]);

  return { seen, markSeen };
}
